import { render, staticRenderFns } from "./PracticeSumupDetailCurriculum.vue?vue&type=template&id=22eec892&scoped=true&"
import script from "./PracticeSumupDetailCurriculum.vue?vue&type=script&lang=ts&"
export * from "./PracticeSumupDetailCurriculum.vue?vue&type=script&lang=ts&"
import style0 from "./PracticeSumupDetailCurriculum.vue?vue&type=style&index=0&id=22eec892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eec892",
  null
  
)

export default component.exports